import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { StaffType } from "src/types";
import { mockStaff } from "../components/templates/design1/components";
import { transformUnit, Unit } from "./useFetchUnits";
import { cleanAndCapitalize } from "./useCompanyStaff";


interface RawStaffType {
    id: number;
    title: string;
    professional_title: string;
    name: string;
    email: string;
    tier: number;
    phone: string;
    username: string | null;
    gender: "male" | "female" | string; // Adjust as needed
    position: string;
    state: string | null;
    local_government: string | null;
    branch_picture: string;
    address: string | null;
    picture: string;
    user_id: number;
    status: string;
    branch_id: string;
    company_id: number;
    year_of_experience: number;
    company_logo: string;
    about_staff: {
        note: string | null;
    }
    property_count: number;
    unit_count: number;
    rent_count: number;
    staff_unit: Unit[];
}


// Get the base URL from environment variables
const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL;
// Function to fetch staff details by ID
export const fetchStaffById = async (id: number): Promise<StaffType> => {
    const isDemo = process.env.NEXT_PUBLIC_DEMO_MODE === "true";
    if (isDemo) {
        console.log("demo")
        return mockStaff
    }
    const response = await axios.get<{ status: string; staff: RawStaffType }>(
        `${BASE_URL}api/v1/custom/company-staff-details/${id}`
    );


    const data: StaffType = {
        id: response.data.staff.id,
        email: response.data.staff.email,
        tier: response.data.staff.tier,
        phone: response.data.staff.phone,
        position: response.data.staff.professional_title,
        gender: response.data.staff.gender,
        staffListing: response?.data?.staff?.staff_unit?.map(transformUnit),
        username: response.data.staff.username,
        local_government: response.data.staff.local_government,
        address: response.data.staff.address,
        picture: response.data.staff.picture,
        company_id: response.data.staff.company_id,
        companyImage: response.data.staff.branch_picture,
        user_id: response.data.staff.user_id,
        stats: {
            property_for_rent: response.data.staff.rent_count,
            property_for_sale: 0,
            property_for_short_let: 0,
            total_unit_managing: response.data.staff.unit_count,
            years_in_business: response.data.staff.year_of_experience as unknown as string,
            company_position: response.data.staff.position,
        },
        about_staff: response?.data.staff?.about_staff as unknown as string,
        branch_id: response.data.staff.branch_id,
        state: response.data.staff.state,
        name: cleanAndCapitalize(`${response.data.staff.title} ${response.data.staff.name}`),
        title: response.data.staff.title,
        real_estate_title: response.data.staff.professional_title,

    }
    return data;
};
export const useStaffDetails = (id: number) => {
    return useQuery({
        queryKey: ["staff", id],
        queryFn: () => fetchStaffById(id),
        enabled: !!id, // Only fetch if ID is provided
    });
};
